
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {CategoryDialogComponent} from "./dialog/categoryDialog.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {ServiceCategoriesResolve} from "./resolve/serviceCategories.resolve";

@NgModule({
    declarations: [
        CategoryDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTooltipModule,
        MatDialogModule,
        MatToolbarModule,
        TranslateModule,
    ],
    providers: [
        ServiceCategoriesResolve,
    ],
    bootstrap: [CategoryDialogComponent]
})
export class CategoryModule { }
